import { render, staticRenderFns } from "./BuscadorAcuerdos.vue?vue&type=template&id=28eebf32"
import script from "./BuscadorAcuerdos.vue?vue&type=script&lang=js"
export * from "./BuscadorAcuerdos.vue?vue&type=script&lang=js"
import style0 from "./BuscadorAcuerdos.vue?vue&type=style&index=0&id=28eebf32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports